import ConsumerDailyService from "@api/consumer/consumerDailyService";
import { IGiftGroupShort } from "@interfaces/consumer/daily";
import { FC, useState } from "react";
import { Link, useNavigate } from "react-router";
import { ColumnDef } from "@tanstack/react-table";
import { useRemoteTable } from "@hooks/tableHooks";
import { Card, Form } from "react-bootstrap";
import { Flex, IconButton } from "@components/falcon/common";
import { AdvanceTable, AdvanceTableFooter, AdvanceTableSearchBox } from "@components/falcon/common/tables";
import AdvanceTableProvider from "@components/falcon/common/tables/context";
import { useRole } from "@services/hooks";
import {dateFormatter} from "@/services";

const columns: ColumnDef<IGiftGroupShort>[] = [
    {
        accessorKey: 'name',
        header: 'Название',
        enableSorting: true,
        meta: {
            headerProps: { className: 'pe-1 text-900' },
            cellProps: { className: 'py-2' }
        },
        cell: ({row: {original: {id, name}}}) => (
            <Link to={`/consumer/daily/groups/${id}/`}>
                <Flex alignItems="center" className="flex-1">
                    <h5 className="mb-0 fs-10">{name}</h5>
                </Flex>
            </Link>
        )
    },
    {
        accessorKey: 'isActive',
        header: 'Активно',
        enableSorting: false,
        meta: {
            headerProps: { className: 'text-center text-900' },
            cellProps: { className: 'text-center' }
        },
        cell: ({row: {original: {isActive}}}) => (
            <Form.Check type="checkbox" defaultChecked={isActive} disabled />
        )
    },
    {
        accessorKey: 'startTime',
        header: 'Время начала',
        enableSorting: false,
        cell: ({row: {original: {startTime}}}) => dateFormatter(startTime),
        meta: {
            headerProps: { className: 'text-900' }
        }
    },
    {
        accessorKey: 'endTime',
        header: 'Время окончания',
        enableSorting: false,
        cell: ({row: {original: {endTime}}}) => dateFormatter(endTime),
        meta: {
            headerProps: { className: 'text-900' }
        }
    }
]

const GiftGroupsList: FC = () => {

    const [api] = useState(() => new ConsumerDailyService());
    const navigate = useNavigate();
    const canEdit = useRole('consumer.daily.edit');

    const table = useRemoteTable({
        name: 'consumer.daily.groups',
        columns,
        defaultState: {
            sorting: [{id: 'name', desc: false}]
        }
    }, api.fetchGiftGroupsList);

    return (
        <AdvanceTableProvider table={table}>
            <Card className="mb-3">
                <Card.Header>
                    <Flex className='align-items-center justify-content-between'>
                        <Flex alignItems="center" className="fs-10">
                            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Группы бонусов</h5>
                        </Flex>
                        <Flex>
                            {canEdit && (
                                <IconButton
                                    variant="falcon-default"
                                    size="sm"
                                    icon="plus"
                                    transform="shrink-3"
                                    className='me-2'
                                    onClick={() => navigate('/consumer/daily/groups/add/')}
                                >
                                    <span className="d-none d-sm-inline-block ms-1">Создать</span>
                                </IconButton>
                            )}
                            <Flex><AdvanceTableSearchBox/></Flex>
                        </Flex>
                    </Flex>
                </Card.Header>
                <Card.Body className="p-0">
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs-10 mb-0 overflow-hidden'
                        }}
                    />
                </Card.Body>
                <Card.Footer>
                    <AdvanceTableFooter
                        rowInfo
                        rowsPerPageSelection
                        paginationButtons
                    />
                </Card.Footer>
            </Card>
        </AdvanceTableProvider>
    )
}

export default GiftGroupsList;
